export default __webpack_public_path__ + "static/media/backdrop.f392f138.png";